import { useMap } from '@vis.gl/react-google-maps';
import { useSelector } from 'react-redux';
import React, { useEffect } from 'react';

function GoogleMapHandler() {
  const map = useMap();
  const place = useSelector((state) => state.resellermaplist.autocompletePlace);

  useEffect(() => {
    if (!map || !place) return;

    if (place.geometry?.viewport) {
      map.fitBounds(place.geometry.viewport);
    }
    else if (place.geometry?.location) {
      map.setCenter(place.geometry.location);
      map.setZoom(12);
    }
  }, [map, place]);
  return null;
}

export default React.memo(GoogleMapHandler);